export interface PortCallActuals {
    pilotStationArrivalAt: string | null;
    pilotOnAt: string | null;
    arrivalAt: string | null;
    departureAt: string | null;
    pilotOffAt: string | null;
}

export interface SimplifiedPortCall {
    // Either gsisId or localId will always be set (localId will only be used for portcalls added locally)
    gsisId: null | number;
    localId: null | number;
    terminalCode: string;
    arrivalAt: string;
    departureAt: string;
    omitted: boolean;
    actuals: PortCallActuals;
    serviceCode?: string;
    operatorCode?: string;
    estimatedpilotboarding?: string;
    estimatedpilotdropoff?: string;
}

export interface ScheduleEntry {
    id: string;
    departureTerminalCode: string;
    departureTerminalUnLocode: string;
    departureAt: string;
    arrivalTerminalCode: string;
    arrivalTerminalUnLocode: string;
    arrivalAt: string;
    etd: number;
    eta: number;
    progress: number;
    active?: boolean;
    inPort?: boolean;
    arrivalPortCall?: {
        current: SimplifiedPortCall;
        GSIS: SimplifiedPortCall | null;
    };
    departurePortCall?: {
        current: SimplifiedPortCall;
        GSIS: SimplifiedPortCall | null;
    };
    omitted?: boolean;
}


export interface ScheduleVesselAvailabilityGap {
    from: string;
    to: string;
}

export interface ScheduleVesselAvailability {
    name: string;
    firstPortCallArrivalAt: string;
    lastPortCallArrivalAt: string;
    gaps: ScheduleVesselAvailabilityGap[];
    isCurrentlyAvailable: boolean;
}

export interface CurrentScheduleState {
    startPort: string;
    endPort: string;
    startTime: number;
    endTime: number;
    inPort: boolean;
    serviceCode?: string | null;
    operatorCode?: string | null;
    id: string;
}

export interface IMOsCurrentScheduleState {
    imoNo: number;
    schedule: CurrentScheduleState;
}

export enum ScheduleEvents {
    ScheduleUpdated = 'schedule-updated',
    ScheduleStatesUpdated = 'schedule-states-updated',
}

export interface GetSchedulePromise {
    promise: Promise<ScheduleEntry[]>;
}

export interface ScheduleCacheEntry {
    timestamp: number;
    schedule: ScheduleEntry[];
}